import Home from "./container/redeSIM.home";
import ResponderExigenciaSubForm from "./components/responderExigencia/container/responderExigencia.subform";
import SolicitarDocumentoSubForm  from "./components/solicitarDocumento/container/solicitarDocumento.subform";
import ConsultarProtocoloSubForm  from "./components/consultarProtocolo/container/consultarProtocolo.subform";
import SolicitarBaixaMeiSubForm from "./components/solicitarBaixaMei/container/solicitarBaixaMei.subform";
import ImprimirSolicitacaoSubForm from "./components/imprimirSolicitacao/container/imprimirSolicitacao.subform";

const routes = [
  {
    name: "RedeSIM",
    path: "/redesim",
    component: Home,
    breadCrumb: [{ text: "Serviços Complementares Sistema Rede SIM" }]
  },
  {
    name: "redeSIM.responderExigencia",
    path: "/redesim/responderexigencia",
    component: ResponderExigenciaSubForm,
    breadCrumb: [{ text: "Serviços Complementares Sistema Rede SIM", link: "/redesim" }, { text: "Responder Exigência" }]
  },
  {
    name: "redeSIM.solicitarDocumento",
    path: "/redesim/solicitardocumento",
    component: SolicitarDocumentoSubForm,
    breadCrumb: [{ text: "Serviços Complementares Sistema Rede SIM", link: "redesim" }, { text: "Solicitar Documento" }]
  },
  {
    name: "redeSIM.consultarProtocolo",
    path: "/redesim/consultarprotocolo",
    component: ConsultarProtocoloSubForm,
    breadCrumb: [{ text: "Serviços Complementares Sistema Rede SIM", link: "redesim" }, { text: "Consultar Protocolo" }]
  },
  {
    name: "redeSIM.solicitarBaixaMei",
    path: "/redesim/solicitarBaixaMei",
    component: SolicitarBaixaMeiSubForm,
    breadCrumb: [{ text: "Serviços Complementares Sistema Rede SIM", link: "redesim" }, { text: "Solicitar Baixa Mei" }]
  },
  {
    name: "redeSIM.imprimirSolicitacao",
    path: "/redesim/imprimirSolicitacao",
    component: ImprimirSolicitacaoSubForm,
    breadCrumb: [{ text: "Serviços Complementares Sistema Rede SIM", link: "redesim" }, { text: "Imprimir Solicitação" }]
  },
];

export default routes;
